// extracted by mini-css-extract-plugin
export default {"remainingChars":"styles_remainingChars__rokAZ","exceededLimit":"styles_exceededLimit__1pEe+"};